import React from "react";
import { Col, Row } from "antd";
import { FormInstance } from "antd/es/form/hooks/useForm";
import { ErrorValueType } from "../../../stores/cmr/CreateCmrStore";
import Authorize from "../../Authorize";
import { ROLE_ADMIN, ROLE_CLIENT } from "../../../constants/authorize";
import Field from "../../common/forms/field";
import CarriagePayments from "./CarriagePayments";
import config from "./config";
import Form from "../../common/forms/form";
import { Option } from "../../common/forms/Interfaces";
import WithoutRole from "../../Authorize/withoutRole";

interface Props {
  form: FormInstance;
  errors: { [key: string]: ErrorValueType };
  initialValues: { [key: string]: any };
  onFinish: (values: Object) => void;
  onSaveAndDownloadPdf: (values: Object) => void;
  onCancel: () => void;
  countries?: Option[];
  departments?: Option[];
  clients?: Option[];
  footer?: React.ReactElement;
}

const gutter = { gutter: 15 };

const getFooter = (footer?: React.ReactElement): React.ReactElement | null => {
  if (footer) {
    return (
      <Row className="create-cmr-form__footer" {...gutter}>
        {footer}
      </Row>
    );
  }

  return null;
};

const CmrForm: React.FC<Props> = ({
  form,
  errors,
  initialValues,
  onFinish,
  countries,
  departments,
  clients,
  footer,
}) => (
  <Form
    form={form}
    errors={errors}
    config={config}
    onFinishHandler={onFinish}
    initialValues={initialValues}
    className="create-cmr-form"
  >
    <Row {...gutter}>
      <Col span={8}>
        <Field name="cmr_number" />
      </Col>
      <Authorize role={ROLE_ADMIN}>
        <Col span={8}>
          <Field name="department_id" options={departments} />
        </Col>
      </Authorize>
      <WithoutRole role={ROLE_CLIENT}>
        <Col span={8}>
          <Field name="user_id" options={clients} />
        </Col>
      </WithoutRole>
    </Row>
    <Row {...gutter} justify="space-between">
      <Col span={12}>
        <b className="create-cmr-form__head">1.</b> Sender (name, address,
        country)
        <Field name="consignor" options={countries} />
        <Field name="consignor_address" options={countries} />
        <Field name="consignor_country" options={countries} />
        <Field name="consignor_note" />
      </Col>
      <Col span={12}>
        <p>
          MIEDZYNARODOWY SAMOCHODOWY LIST
          <br />
          PRZEWOZOWY INTERNATIONAL
          <br />
          CONSIGNEMENT NOTE № 2021021003 Niniejszy przewóz podlega
          postanowianiom konwencji o umowie miedzynarodowej prze- clause to the
          contrary, to the Convention on wozu drogowego towarów (CMR) bez wzglę-
          the Contract for the international Carriage of du na jakąkolwiek
          przeciwną klauzulę. goods by road (CMR)
        </p>
      </Col>
    </Row>
    <Row {...gutter}>
      <Col span={12}>
        <b className="create-cmr-form__head">2.</b> Consignee (name, address,
        country)
        <Field name="consignee" />
        <Field name="consignee_address" />
        <Field name="consignee_country" options={countries} />
        <Field name="consignee_note" />
      </Col>
      <Col span={12}>
        <b className="create-cmr-form__head">16.</b> Carrier (name, address,
        country)
        <Field name="carrier_truck_number" />
        <Field name="carrier" />
        <Field name="carrier_address" />
        <Field name="carrier_country" options={countries} />
      </Col>
    </Row>
    <Row {...gutter}>
      <Col span={12}>
        <b className="create-cmr-form__head">3.</b> Place of delivery of the
        goods (place, country)
        <Field name="unloading_place" />
        <div>
          <Field name="unloading_country" options={countries} />
        </div>
      </Col>
      <Col span={12}>
        <b className="create-cmr-form__head">17.</b> Succesive carriers (name,
        address, country)
        <Field name="next_truck_number" />
        <Field name="next_carrier" />
        <Field name="next_carrier_address" />
        <Field name="next_carrier_country" options={countries} />
      </Col>
    </Row>
    <Row {...gutter}>
      <Col span={12}>
        <Row {...gutter}>
          <Col span={24}>
            <b className="create-cmr-form__head">4.</b> Place and date of taking
            over the goods (place, country, date)
            <Field name="loading_place" />
            <Field name="loading_country" options={countries} />
            <Field name="loading_date" />
          </Col>
        </Row>
      </Col>
      <Col span={12}>
        <b className="create-cmr-form__head">18.</b> Carrier&apos;s reservations
        and observations
        <Field name="comments_of_carrier" />
      </Col>
    </Row>

    <Row {...gutter}>
      <Col span={12}>
        <b className="create-cmr-form__head">5.</b> Documents attached date
        <Field name="invoice" />
      </Col>
    </Row>

    <Row {...gutter}>
      <Col span={24}>
        <Field name="documents" />
      </Col>
    </Row>

    <Row {...gutter}>
      <Col span={15}>
        <Row>
          <Col span={6}>
            <b className="create-cmr-form__head">6.</b> Marks and Nos
          </Col>
          <Col span={6}>
            <b className="create-cmr-form__head">7.</b> Number of pakages
          </Col>
          <Col span={6}>
            <b className="create-cmr-form__head">8.</b> Method of packing
          </Col>
          <Col span={6}>
            <b className="create-cmr-form__head">9.</b> Nature of the goods
          </Col>
        </Row>
      </Col>
      <Col span={9}>
        <Row>
          <Col span={8}>
            <b className="create-cmr-form__head">10.</b> Statistical number
          </Col>
          <Col span={8}>
            <b className="create-cmr-form__head">11.</b> Gross weight in kg
          </Col>
          <Col span={8}>
            <b className="create-cmr-form__head">12.</b> Volume in m3
          </Col>
        </Row>
      </Col>
    </Row>

    <Row {...gutter}>
      <Col span={15}>
        <Field name="cargo" />
        <Field name="total" />
      </Col>
      <Col span={3}>
        <Field name="statistic_number" />
      </Col>
      <Col span={3}>
        <Field name="brutto" />
      </Col>
      <Col span={3}>
        <Field name="volume" />
      </Col>
    </Row>

    <Row {...gutter}>
      <Col span={15}>
        <Row {...gutter}>
          <Col span={6}>
            <Field name="class" />
          </Col>
          <Col span={6}>
            <Field name="digit" />
          </Col>
          <Col span={6}>
            <Field name="letter" />
          </Col>
          <Col span={6}>
            <Field name="additional_address" />
          </Col>
        </Row>
      </Col>
    </Row>

    <Row {...gutter}>
      <Col span={12}>
        <Col span={24}>
          <b className="create-cmr-form__head">13.</b> Sender&apos;s
          instructions
          <Field name="destination_customs" />
          <Field name="consignor_instructions" />
        </Col>
        <Col span={24}>
          <b className="create-cmr-form__head">14.</b> Instruction as to
          payement carriage
          <Field name="terms_of_payment" />
          <Field name="carriage_paid" />
          <Field name="carriage_unpaid" />
        </Col>
      </Col>
      <Col span={12}>
        <Col span={24}>
          <b className="create-cmr-form__head">19.</b> Special agreements
          <Field name="special_agreements" />
        </Col>
        <Col span={24}>
          <CarriagePayments />
        </Col>
      </Col>
    </Row>

    <Row {...gutter}>
      <Col span={1}>
        <b className="create-cmr-form__head">21.</b>
      </Col>
      <Col span={7}>
        <Field name="cmr_place" />
      </Col>
      <Col span={4}>
        <Field name="cmr_date" />
      </Col>
      <Col span={1}>
        <b className="create-cmr-form__head">15.</b>
      </Col>
      <Col span={11}>
        <Field name="cash_on_delivery" />
      </Col>
    </Row>
    <Row {...gutter}>
      <Col span={1}>
        <b className="create-cmr-form__head">22.</b>
      </Col>
      <Col span={23}>
        <Field name="sender_signature_and_stamp" />
      </Col>
    </Row>
    {getFooter(footer)}
  </Form>
);

export default CmrForm;
